<template>
  <v-footer height="auto" color="#00a745">
    <v-layout justify-center row wrap>
      <v-btn
        v-for="link in links"
        :key="link.name"
        color="white"
        flat
        round
        :to="link.name"
        >{{ link.title }}</v-btn
      >
      <v-btn color="white" flat round href="/api/help">
        {{ $t('manual') }}
      </v-btn>
      <v-btn color="white" flat round href="/api/conditions">
        {{ $t('terms_cond') }}
      </v-btn>
      <v-flex black py-3 xs12>
        <v-layout justify-center row wrap>
          <v-flex black py-3 text-xs-center white--text xs11>
            &copy;2021 —
            <strong>Novum Global, a.s.</strong>
            <span class="ml-2">version: {{ version }}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { title: this.$t('about'), name: '/about' },
        { title: this.$t('contact_us'), name: '/contact' },
        { title: this.$t('products'), name: '/product_list' }
      ],
      version: process.env.VUE_APP_VERSION
    }
  }
}
</script>
